import Layout from "@/components/feature/Layout";
import PageHero from "@/components/feature/PageHero";
import MapEmbed from "@/components/feature/MapEmbed";
import Button from "@/components/base/Button";
import CTASection from "@/components/feature/CTASection";
import { useSiteData } from "@/context/SiteDataContext";
import { useT } from "@/lib/useSiteText";

export default function Ubicacion() {
  const { data, whatsappLink } = useSiteData();
  const t = useT();
  const etiqueta = t("ubicacion.etiqueta");
  const descripcion = t("ubicacion.descripcion");
  const rutasEtiqueta = t("ubicacion.rutas_etiqueta");
  const hero = data.pages.ubicacion;
  const comoLlegar = data.contentBlocks.ubicacion?.como_llegar ?? [];
  const accesos = data.contentBlocks.ubicacion?.accesos ?? [];

  return (
    <Layout>
      <PageHero
        titulo={hero.hero_titulo}
        descripcion={hero.hero_descripcion}
        imagen={hero.hero_imagen_url}
        alt={hero.hero_imagen_alt}
      />

      <section className="bg-background-50">
        <div className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-start">
            <div>
              {etiqueta && <span className="text-sm font-semibold text-accent-600">{etiqueta}</span>}
              <h2 className="mt-2 font-heading font-bold text-2xl md:text-3xl text-foreground-950">
                {t("ubicacion.titulo")}
              </h2>
              {descripcion && <p className="mt-4 text-foreground-600 leading-relaxed">{descripcion}</p>}
              <p className="mt-3 text-foreground-600 leading-relaxed">{data.siteSettings.address}</p>

              <div className="mt-7 grid grid-cols-1 sm:grid-cols-2 gap-4">
                {accesos.map((a) => (
                  <div key={a.id} className="flex gap-3 rounded-lg bg-background-100 p-4">
                    <span className="w-10 h-10 shrink-0 rounded-lg bg-primary-100 text-primary-600 flex items-center justify-center">
                      <i className={`${a.icono} text-lg`} />
                    </span>
                    <div>
                      <h3 className="font-heading font-semibold text-foreground-900 text-sm">{a.titulo}</h3>
                      <p className="mt-0.5 text-xs text-foreground-600">{a.descripcion}</p>
                    </div>
                  </div>
                ))}
              </div>

              <div className="mt-7 flex flex-col sm:flex-row gap-3">
                <Button href={whatsappLink(t("wa.agendar_visita"))} variant="accent" icon="ri-whatsapp-line">
                  {t("ubicacion.boton_whatsapp")}
                </Button>
                <Button to="/contacto" variant="outline">
                  {t("ubicacion.boton_visita")}
                </Button>
              </div>
            </div>

            <MapEmbed
              query={data.siteSettings.map_query}
              embedUrl={data.siteSettings.map_embed_url}
              linkUrl={data.siteSettings.map_url}
              className="h-[380px] md:h-[460px]"
            />
          </div>
        </div>
      </section>

      <section className="bg-background-100">
        <div className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
          <div className="max-w-2xl">
            {rutasEtiqueta && <span className="text-sm font-semibold text-accent-600">{rutasEtiqueta}</span>}
            <h2 className="mt-2 font-heading font-bold text-2xl md:text-3xl text-foreground-950">
              {t("ubicacion.rutas_titulo")}
            </h2>
          </div>
          <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-6">
            {comoLlegar.map((item) => (
              <div key={item.id} className="rounded-lg bg-background-50 border border-background-200 p-6">
                <div className="flex items-center justify-between">
                  <h3 className="font-heading font-semibold text-foreground-900">{item.desde}</h3>
                  <span className="rounded-full bg-accent-100 text-accent-800 px-3 py-1 text-xs font-bold whitespace-nowrap">
                    {item.tiempo}
                  </span>
                </div>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{item.ruta}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CTASection titulo={hero.cta_titulo ?? undefined} descripcion={hero.cta_descripcion ?? undefined} />
    </Layout>
  );
}